module.exports = __webpack_public_path__ + "static/media/14.2d1c87f6.mp3";